import React from 'react'

import { Box, Typography } from "@mui/material"


export default function normalizedDataColumn() {

	return {
		name: 'normalizedData',
		label: 'Normalized Data',
		options: {
			headerAlign: 'left',
			customBodyRowRenderLite: value => <Box>
				<Typography>{value}</Typography>
			</Box>,
		}
	}
}